var _excluded = ["variation", "config", "enableSearch", "hidePhoneNumber", "isCorporate", "withAbsoluteLinks", "absoluteBaseUrl"],
    _excluded2 = ["variation", "config", "enableSearch", "hidePhoneNumber", "isCorporate", "invertSmallHeader", "withAbsoluteLinks", "absoluteBaseUrl"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import { focusOutlineColor, focusOutlineOffset, focusOutlineStyle, focusOutlineWidth } from "@nib-components/theme";
import { SearchSystemIcon } from "@nib/icons";
import { PrimaryButton } from "@nib-components/button";
import { Inline, Container, breakpoint, px, py, mr } from "@nib/layout";
import Logo from "@nib-components/logo";
import Ribbon from "./Ribbon";
import variantConfig from "../config";
import { SmallHeader } from "../SmallHeader";
import { HeaderWrapper, HeaderContainer, LogoLink, HeaderContact, PhoneNumber, PhoneIcon, HeaderLinks, SearchLink, HeaderNav, NavMenu, baseNavLinkStyles, NavLinkItem, SEARCH_URL } from "../shared";
var SmallHeaderBelowXl = styled(SmallHeader)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), breakpoint("xl")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    // Styled components has a serious issue with client-side hydration style order.\n    // See issue: https://github.com/styled-components/styled-components/issues/3482\n    // This is our way of compensating for unpredictable style order.\n    &&& {\n      display: none;\n    }\n  "]))));
var HeaderButton = styled(PrimaryButton).attrs({
  color: "light"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n\n  ", "\n\n  &:focus {\n    outline: ", " ", " ", ";\n    outline-offset: ", ";\n  }\n"])), mr(5), breakpoint("xl", "xxl")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n  "])), mr(3)), focusOutlineWidth, focusOutlineStyle, focusOutlineColor, focusOutlineOffset);
var NavLink = styled.a(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  font-size: 18px;\n\n  ", "\n"])), baseNavLinkStyles, py(6), px(5), breakpoint("xl", "xxl")(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    font-size: 1rem;\n    ", ";\n    ", ";\n  "])), py(5), px(3)));
export var HeaderTop = function HeaderTop(props) {
  var _props$variation = props.variation,
      variation = _props$variation === void 0 ? "arhi" : _props$variation,
      config = props.config,
      _props$enableSearch = props.enableSearch,
      enableSearch = _props$enableSearch === void 0 ? false : _props$enableSearch,
      _props$hidePhoneNumbe = props.hidePhoneNumber,
      hidePhoneNumber = _props$hidePhoneNumbe === void 0 ? false : _props$hidePhoneNumbe,
      isCorporate = props.isCorporate,
      withAbsoluteLinks = props.withAbsoluteLinks,
      absoluteBaseUrl = props.absoluteBaseUrl,
      otherProps = _objectWithoutProperties(props, _excluded);

  var dataSource = config ? config : variantConfig[variation]({
    withAbsoluteLinks: withAbsoluteLinks,
    absoluteBaseUrl: absoluteBaseUrl
  });
  var id = dataSource.id,
      logoUrl = dataSource.logoUrl,
      callToAction = dataSource.callToAction,
      phoneNumber = dataSource.phoneNumber,
      corporatePhoneNumber = dataSource.corporatePhoneNumber,
      ribbon = dataSource.ribbon;
  var defaultOrCorporatePhoneNumber = isCorporate && corporatePhoneNumber ? corporatePhoneNumber : phoneNumber;
  var logoLink = logoUrl ? logoUrl : "/";
  var CustomLogo = dataSource === null || dataSource === void 0 ? void 0 : dataSource.logoComponent;
  var themeContext = useContext(ThemeContext);
  var logoLabel = themeContext.id === "nibLegacy" ? "nib Logo" : "".concat(themeContext.id, " Logo");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderWrapper, _extends({
    id: "".concat(id, "-top")
  }, otherProps), ribbon && ribbon.length > 0 && /*#__PURE__*/React.createElement(Ribbon, {
    data: ribbon
  }), /*#__PURE__*/React.createElement(HeaderContainer, null, /*#__PURE__*/React.createElement(LogoLink, {
    href: logoLink,
    id: "ga-inlink-logo-homepage-desktop",
    "aria-label": logoLabel
  }, CustomLogo ? /*#__PURE__*/React.createElement(CustomLogo, {
    size: "header"
  }) : /*#__PURE__*/React.createElement(Logo, {
    size: "header"
  })), defaultOrCorporatePhoneNumber && !hidePhoneNumber && /*#__PURE__*/React.createElement(HeaderContact, null, /*#__PURE__*/React.createElement(PhoneNumber, {
    href: "tel:".concat(defaultOrCorporatePhoneNumber && defaultOrCorporatePhoneNumber.replace(/\s+/g, "")),
    id: "ga-nav-".concat(variation !== "arhi" ? "".concat(variation, "-") : "", "call-desktop"),
    className: "js-phone-number-call-tracking t-header-phone-number",
    "aria-label": "Call nib"
  }, /*#__PURE__*/React.createElement(Inline, {
    space: 2
  }, /*#__PURE__*/React.createElement(PhoneIcon, null), /*#__PURE__*/React.createElement("span", null, defaultOrCorporatePhoneNumber)))), /*#__PURE__*/React.createElement(HeaderLinks, null, enableSearch && /*#__PURE__*/React.createElement(SearchLink, {
    id: "ga-nav-search-desktop",
    href: SEARCH_URL
  }, /*#__PURE__*/React.createElement(SearchSystemIcon, null)), callToAction && /*#__PURE__*/React.createElement(HeaderButton, {
    component: "a",
    id: "".concat(callToAction.id, "-desktop"),
    href: callToAction.url
  }, callToAction.title)))));
};
export var HeaderMenu = function HeaderMenu(props) {
  var _props$variation2 = props.variation,
      variation = _props$variation2 === void 0 ? "arhi" : _props$variation2,
      config = props.config,
      _props$enableSearch2 = props.enableSearch,
      enableSearch = _props$enableSearch2 === void 0 ? false : _props$enableSearch2,
      _props$hidePhoneNumbe2 = props.hidePhoneNumber,
      hidePhoneNumber = _props$hidePhoneNumbe2 === void 0 ? false : _props$hidePhoneNumbe2,
      isCorporate = props.isCorporate,
      invertSmallHeader = props.invertSmallHeader,
      withAbsoluteLinks = props.withAbsoluteLinks,
      absoluteBaseUrl = props.absoluteBaseUrl,
      otherProps = _objectWithoutProperties(props, _excluded2);

  var dataSource = config ? config : variantConfig[variation]({
    withAbsoluteLinks: withAbsoluteLinks,
    absoluteBaseUrl: absoluteBaseUrl
  });
  var id = dataSource.id,
      navAlignment = dataSource.navAlignment,
      navLinks = dataSource.navLinks;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderWrapper, _extends({
    id: "".concat(id, "-menu")
  }, otherProps, {
    as: "div"
  }), /*#__PURE__*/React.createElement(HeaderNav, {
    "aria-label": "Main navigation"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(NavMenu, {
    navAlignment: navAlignment
  }, navLinks && navLinks.map(function (link) {
    return /*#__PURE__*/React.createElement(NavLinkItem, {
      link: link,
      key: link.id,
      navLink: NavLink
    });
  }))))), /*#__PURE__*/React.createElement(SmallHeaderBelowXl, {
    enableSearch: enableSearch,
    hidePhoneNumber: hidePhoneNumber,
    variation: variation,
    config: config,
    showMenu: true,
    isCorporate: isCorporate,
    invert: invertSmallHeader,
    withAbsoluteLinks: withAbsoluteLinks,
    absoluteBaseUrl: absoluteBaseUrl
  }));
};
export var Header = function Header(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderTop, props), /*#__PURE__*/React.createElement(HeaderMenu, props));
};
Header.displayName = "Header";
Header.HeaderWrapper = HeaderWrapper;
Header.SmallHeader = SmallHeaderBelowXl;
Header.LogoLink = LogoLink;
Header.HeaderNav = HeaderNav;
Header.HeaderLinks = HeaderLinks;
Header.SearchLink = SearchLink;
Header.defaultProps = {
  variation: "arhi",
  isCorporate: false,
  invertSmallHeader: false,
  withAbsoluteLinks: false
};